<div
  class="body ui container fluid"
  fxLayout="column"
  fxLayoutAlign="flex-start none"
>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <label class="ui grey">Home / Settings / Application Security</label>
        <h2 class="ui primary header">IP Management</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button
        class="ui small basic blue button"
        (click)="onConfigureIpAdddressModal('config')"
      >
        Configure Blocked IP Address Response
      </button>
      <button
        class="ui small primary button"
        (click)="openBlacklistIPAddressModal()"
      >
        Blacklist IP
      </button>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div>
    <app-search-filter
      [filter]="filter"
      (onSearch)="searchRecords($event)"
      (onDisplayRows)="displayRecords($event)"
      (onSort)="sortRecords($event)"
    ></app-search-filter>

    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>

      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
      <div
        fxLayout="row"
        tamsyMargin
        class="ui segment"
        marginB="3"
        fxLayoutGap="15px"
        fxLayoutAlign="start stretch"
        id="dark"
      >
        <div fxFlex="20">IP Address</div>
        <div fxFlex="35">Description</div>
        <div fxFlex="20">Blacklisted By</div>

        <div fxFlex="20">Blacklisted On</div>
        <div fxFlex="5"></div>
      </div>
      <app-ip-management-row
        *ngFor="let ip of ipManagementList"
        [ip]="ip"
        (viewLog)="viewLogDetail($event)"
        (whitelistIpAddress)="whitelistIPAddressModal($event)"
      ></app-ip-management-row>
      <app-no-record-found
        *ngIf="ipManagementList && ipManagementList.length < 1"
      ></app-no-record-found>

      <div class="ui vertical basic segment">
        <div class="ui two column grid">
          <div class="column middle aligned">
            <div class="ui icon small button">
              <i class="database icon"></i>
            </div>
            <a class="ui basic label">{{ totalItems }} Record(s)</a>
          </div>
          <div
            class="column right aligned pagination menu"
            style="margin-left: auto"
          >
            <sui-pagination
              class="small"
              [collectionSize]="totalItems"
              [pageSize]="rows"
              [maxSize]="maxSize"
              [hasEllipses]="false"
              [page]="currentPage"
              (pageChange)="nextPage($event)"
            >
            </sui-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
